import React from 'react'
import { icons } from '@/shahrzad-assets/shared-asstes/icons'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { styled } from 'styled-components'
import { Breakpoint } from 'react-socks'
import { Col, Row } from 'antd'
import ProfileSmallUp from './ProfileSmallUp'
import SideBarSmallUp from './SideBarSmallUp'
import WalletCharge from './WalletCharge'
import { colors } from '@/shahrzad-assets/shared-constants/colors'
import { Link, useNavigate } from 'react-router-dom'
import { sharedPathes } from '@/shahrzad-assets/shared-routing/pathe'
import CustomButton from '../CustomButton'
import { getAccessToken } from '@/shahrzad-assets/shared-constants/localstorage'

const HeaderSmallUp = ({ extraComponent: ExtraComponent, tiles }: any) => {
  const navigate = useNavigate()

  const goToLoginPage = () => {
    navigate(sharedPathes.LOGIN_USERNAME, { replace: true});
  }
  return (
    <Breakpoint large up>
      <TopSection>
        <Row align='middle' justify='space-between'>
          <Right>
            <Link to={getAccessToken() ? import.meta.env.VITE_MAIN_WEB_URL + sharedPathes.HOME : ""}>
              <img src={icons.LOGO_SHAHRZAD_BLACK} />
            </Link>
            <SideBarSmallUp tiles={tiles} />
          </Right>
          <Left>
            {ExtraComponent && <ExtraComponent />}
            <>
              <WalletCharge />
              {getAccessToken() ? <ProfileSmallUp /> : null}
              {getAccessToken() ? null : (
                <CustomButton onClick={goToLoginPage}>
                  <img src={icons.WHITE_LOGIN} alt='login icon' />
                  ورود یا ثبت نام
                </CustomButton>
              )}
            </>
          </Left>
        </Row>
      </TopSection>
    </Breakpoint>
  )
}

export default HeaderSmallUp

const Right = styled(Col)`
  display: flex;
  align-items: center;
  img {
    &:first-child {
      cursor: pointer;
      padding: ${dimens.SPACING_S} 0;
    }
  }
`

const TopSection = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  padding: ${dimens.SPACING_S} 7rem;
  background-color: ${colors.bg2};
  z-index: 100;
`

const Left = styled(Col)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${dimens.SPACING_XL};
`
